import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const SubCategoryList = (payload) => {
  return axiosInstance.post("/admin/subcategory-list",payload);
};
export const ActiveSubCategoryList = async(categoryId) => {
   const response=await axiosInstance.post("/admin/active-subcategory-list",{ category_id: categoryId,});
  return response; 

};

export const AddSubCategory = (payload) => {
  return axiosInstance.post("/admin/subcategory-store", payload);
};

export const VirwSubCategory = (payload) => {
  return axiosInstance.post("/admin/subcategory-show", payload);
};

export const UpdateSubCategory = async(payload) => {
const res= await  axiosInstance.post("/admin/subcategory-update", payload);
return res.data
};

// Delete
export const DeleteSubCategory = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/subcategory-delete",
    payload
  );

  return response.data;
};

// Status Change
export const ChangeStatusSubCategory = (payload) => {
  return axiosInstance.post("/admin/subcategory-status-update", payload);
};